import React from 'react';
import PropTypes from 'prop-types';
import { Delete, Edit } from '@mui/icons-material';
import { MenuItem, Popover, Tooltip } from '@mui/material';
import { useStyles } from '../../styles/sectionActionPopupStyles';

const popoverProps = {
  anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
  transformOrigin: { vertical: 'top', horizontal: 'right' },
};

const SectionActionPopup = ({ taskCount, onRename, onDelete, ...props }) => {
  const classes = useStyles();
  return (
    <Popover classes={{ paper: classes?.popoverPaper }} {...popoverProps} {...props}>
      <MenuItem onClick={onRename} className={classes?.menuItem}>
        <Edit fontSize="small" color="action" /> Rename section
      </MenuItem>
      {taskCount === 0 ? (
        <MenuItem onClick={onDelete} className={classes?.menuItem}>
          <Delete fontSize="small" color="error" /> Delete section
        </MenuItem>
      ) : (
        <Tooltip title="Empty this section to delete it" placement="bottom" arrow>
          <div>
            <MenuItem disabled className={classes?.menuItem}>
              <Delete fontSize="small" color="disabled" /> Delete section
            </MenuItem>
          </div>
        </Tooltip>
      )}
    </Popover>
  );
};

SectionActionPopup.propTypes = {
  taskCount: PropTypes.number,
  onRename: PropTypes.func,
  onDelete: PropTypes.func,
};

export default SectionActionPopup;
